import Radio from '../radio/radio';
const { Group: RadioGroup } = Radio;

export default RadioGroup;
